import { PlusOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import React from 'react';

interface AddItemButtonProps {
  text?: string;
  onClick?: () => void;
  fontSize?: string;
  fontWeight?: string;
  marginTop?: string;
  width?: string;
  height?: string;
  gap?: string;
}

const AddItemButton: React.FC<AddItemButtonProps> = ({
  text,
  onClick,
  fontSize = '16px',
  fontWeight = '500',
  marginTop = '16px',
  width = '36px',
  gap = 'middle',
  height = '36px',
}) => {
  return (
    <Flex
      onClick={onClick}
      align='center'
      gap={gap || 'middle'}
      style={{
        cursor: 'pointer',
        marginTop: marginTop,
        fontSize: fontSize,
        fontWeight: fontWeight,
        width: 'max-content',
      }}
    >
      <span
        style={{
          background: 'var(--light-gray)',
          width: width,
          height: height,
          borderRadius: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <PlusOutlined
          style={{
            color: 'var(--text-primary)',
          }}
        />
      </span>
      {text}
    </Flex>
  );
};

export default AddItemButton;
